module.exports = __webpack_public_path__ + "static/media/ic_add_organization.d624b124.svg";